/* 
Table utility functions.
*/
import * as formatting from "./formatting.helper";
import _ from "underscore";

export const tableHelper = {
  getBlankCriteriaInfo,
  getCriteriaInfo,
  getDefaultPaging,
  constructUrl,
  getPagingFromHeaders,
  getIndexOfId,
  getPreviousRecordInfo,
  getNextRecordInfo,
  downloadExportedSpreadsheet,
  openInNewWindow
};

function getBlankCriteriaInfo() {
  return {
    hasCriteria: false,
    description: ""
  };
}

function getCriteriaInfo(headers) {
  let criteria = {
    hasCriteria: false,
    description: "",
    criteriaDescription: ""
  };
  criteria.criteriaDescription = headers["x-query-criteriadescription"];
  criteria.hasCriteria = criteria.criteriaDescription !== undefined && criteria.criteriaDescription.length > 0;
  const totalItems = headers["x-query-totalitems"];
  if (totalItems == 0 && !criteria.hasCriteria) {
    criteria.description = "";
  } else {
    if (totalItems > 0) {
      criteria.description += `Showing ${formatting.formatNumber(headers["x-query-recordstart"])}`;
      criteria.description += ` to ${formatting.formatNumber(headers["x-query-recordend"])}`;
      criteria.description += ` of ${formatting.formatNumber(totalItems)} records`;
    } else {
      criteria.description += "No records";
    }
    criteria.description += criteria.hasCriteria ? " where:" : ".";
  }
  return criteria;
}

function getDefaultPaging(sortBy = "Id", descending = true) {
  return {
    page: 1,
    rowsPerPage: 10,
    sortBy,
    descending: descending,
    totalItems: 0,
    pages: 0
  };
}

function constructUrl(searchUrl, ...jsonObjects) {
  for (let json of jsonObjects) {
    searchUrl = addJsonToUrl(searchUrl, json);
  }
  return searchUrl;
}

function addJsonToUrl(url, json) {
  const s = formatting.stringifyObject(json);
  if (s) {
    const separator = url.indexOf("?") >= 0 ? "&" : "?";
    url += separator;
    url += s;
  }
  return url;
}

function getPagingFromHeaders(headers) {
  const paging = {
    page: getIntegerFromHeaders(headers, "x-query-page", 1),
    rowsPerPage: getIntegerFromHeaders(headers, "x-query-rowsperpage", 9999),
    sortBy: headers["x-query-sortby"],
    descending: headers["x-query-descending"] === "True",
    totalItems: getIntegerFromHeaders(headers, "x-query-totalitems", 0)
  };
  paging.pages = Math.max(Math.ceil(paging.totalItems / paging.rowsPerPage), 1);
  return paging;
}

function getIntegerFromHeaders(headers, field, defaultValue) {
  const v = parseInt(headers[field]);
  return isNaN(v) ? defaultValue : v;
}

function getIndexOfId(listing, id) {
  return _(listing.data).findIndex(item => {
    return item.id == id;
  });
}

function getNextRecordInfo(currentRecordIndex, listing, idFieldName = "id") {
  if (currentRecordIndex == -1) {
    return {
      id: null,
      available: false,
      atLimit: false,
      loadPage: false
    };
  } else {
    const atEnd = currentRecordIndex == listing.data.length - 1;
    const paging = listing.paging;
    const onLastPage = isNaN(paging.page) || paging.page == paging.pages;
    let next = { id: null, available: true, atLimit: atEnd && onLastPage, loadPage: atEnd && !onLastPage };
    if (!atEnd) {
      next.id = listing.data[currentRecordIndex + 1][idFieldName];
    }
    return next;
  }
}

function getPreviousRecordInfo(currentRecordIndex, listing, idFieldName = "id") {
  if (currentRecordIndex == -1) {
    return {
      id: null,
      available: false,
      atLimit: false,
      loadPage: false
    };
  } else {
    const atStart = currentRecordIndex == 0;
    const paging = listing.paging;
    const onFirstPage = isNaN(paging.page) || paging.page == 1;
    let previous = { id: null, available: true, atLimit: atStart && onFirstPage, loadPage: atStart && !onFirstPage };
    if (!atStart) {
      previous.id = listing.data[currentRecordIndex - 1][idFieldName];
    }
    return previous;
  }
}

function downloadExportedSpreadsheet(url) {
  window.location.href = url;
}

function openInNewWindow(url) {
  const a = document.createElement("a");
  a.target = "_blank";
  a.href = url;
  a.click();
}
